export interface IObservableCallback {
  (_event: {
    type: string;
    target: any;
    payload: any;
  }): void;
}

interface IObservableListener {
  eventName: string;
  callback: IObservableCallback;
  once?: boolean;
}

abstract class Observable {
  protected listeners: Array<IObservableListener> = [];

  protected dispatchEvent(eventName: string, payload: any): void {
    if (!this.listeners.length) {
      return;
    }
    this.listeners.forEach((item) => {
      if (item.eventName !== eventName || typeof item.callback !== 'function') {
        return;
      }
      if (item.once) {
        this.removeEventListener(item.eventName, item.callback);
      }
      item.callback({
        type: eventName,
        target: this,
        payload,
      });
    });
  }

  public addEventListener(eventName: string, callback: IObservableCallback): CallableFunction {
    this.listeners.push({
      eventName,
      callback,
    });
    return () => {
      this.removeEventListener(eventName, callback);
    };
  }

  public addEventListenerOnce(eventName: string, callback: IObservableCallback): void {
    this.listeners.push({
      eventName,
      callback,
      once: true,
    });
  }

  public removeEventListener(eventName: string, callback: IObservableCallback): void {
    const deleteIndex: number = this.listeners.findIndex((item) => item.eventName === eventName && item.callback === callback);
    if (deleteIndex === -1) {
      return;
    }
    this.listeners.splice(deleteIndex, 1);
  }

  public removeAllListeners(eventName?: string): void {
    if (!this.listeners.length) {
      return;
    }
    if (!eventName) {
      this.listeners.splice(0);
      return;
    }
    const deleteIndexes: Array<number> = this.listeners
      .map((item, key) => (item.eventName === eventName ? key : -1))
      .filter((item) => item > -1);
    deleteIndexes.forEach((deleteIndex) => {
      this.listeners.splice(deleteIndex, 1);
    });
  }
}

export default Observable;
